var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PermissionPage',{attrs:{"title":_vm.title,"description":_vm.description,"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }